import { render, staticRenderFns } from "./playbook-performance.vue?vue&type=template&id=64d8ee7c&"
import script from "./playbook-performance.vue?vue&type=script&lang=js&"
export * from "./playbook-performance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports